import { useSavedChartsStore } from '@/stores/savedChartsStore';
import { INVALID_CHART_LIST_LIST_NUM, isValidChartListListNum } from '@/composables/isValidChartListListNum';
import { INVALID_CHART_LIST_RECID, isValidChartListRecid } from '@/composables/isValidChartListRecid';
import { ChartList } from '@/interfaces/chartList';

export function getChartListFromCache(listNum?: number, recid?: number): ChartList | null {
  const savedChartsStore = useSavedChartsStore();
  const isListNumValid = typeof listNum === 'number' && isValidChartListListNum(listNum);
  const isRecidValid = typeof recid === 'number' && isValidChartListRecid(recid);

  if (!isListNumValid && !isRecidValid) {
    return null;
  }

  const formattedListNum = isListNumValid ? Number(listNum) : INVALID_CHART_LIST_LIST_NUM;
  const formattedRecid = isRecidValid ? Number(recid) : INVALID_CHART_LIST_RECID;

  const cachedChartList = savedChartsStore.chartLists.find((chartList) => {
    if (isListNumValid && isRecidValid) {
      return chartList.listNum === formattedListNum && chartList.recid === formattedRecid;
    }

    if (isListNumValid) {
      return chartList.listNum === formattedListNum;
    }

    return chartList.recid === formattedRecid;
  });

  return cachedChartList ?? null;
}
